import { WalletConnectPublicKey } from './WalletConnectPublicKey';
import { IC_CHAIN_ID, ICMethods } from '../constants';
import { WalletConnectSignIdentity } from './WalletConnectSignIdentity';
export class WalletConnectIdentity extends WalletConnectSignIdentity {
    constructor(publicKey, client, topic) {
        super();
        this.publicKey = publicKey;
        this.client = client;
        this.topic = topic;
    }
    static async createIdentity(client, topic) {
        const publicKey = await WalletConnectPublicKey.getKey(client, topic);
        return new WalletConnectIdentity(publicKey, client, topic);
    }
    setTopic(topic) {
        this.topic = topic;
    }
    getPublicKey() {
        return this.publicKey;
    }
    /**
     * @param blob {ArrayBuffer} - CBOR encoded canister request body
     * @return {Promise<Signature>}
     */
    async sign(blob) {
        const message = Array.from(new Uint8Array(blob));
        const [signature] = await this.client.request({
            topic: this.topic,
            chainId: IC_CHAIN_ID,
            request: {
                method: ICMethods.signData,
                params: [message],
            },
        });
        if (!Array.isArray(signature)) {
            throw new Error('Invalid "signature" type. Response should be an array!');
        }
        return new Uint8Array(signature).buffer;
    }
}
//# sourceMappingURL=WalletConnectIdentity.js.map